import PayrollSummaryReportComponent from 'components/Report/PayrollSummaryReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path as needed

const PayrollSummaryReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<PayrollSummaryReportComponent />
		</PermissionGuard>
	);
};

export default PayrollSummaryReport;
